import { IChatHintSchema } from 'shared/repositories/chats/entities/chat_hint/ChatHintSchema';

import { TChatAction, EChatsActionTypes } from '../../actions/chat';

export interface IOfferChatsState {
  isChatsEnabled: boolean;
  isChatOpened: boolean;
  isOnline: boolean;
  chatId?: string;
  hintQuestions: IChatHintSchema[];
  type?: 'open_phone' | 'open_message';
  defaultMessage?: string;
  shouldSendDefaultMessage?: boolean;
}

const initialState: IOfferChatsState = {
  chatId: undefined,
  isChatsEnabled: false,
  isChatOpened: false,
  isOnline: false,
  hintQuestions: [],
  defaultMessage: undefined,
  shouldSendDefaultMessage: undefined,
};

export function chatReducer(state: IOfferChatsState = initialState, action: TChatAction): IOfferChatsState {
  switch (action.type) {
    case EChatsActionTypes.StateReceived:
      return {
        ...state,
        isChatsEnabled: action.payload.enabled,
      };

    case EChatsActionTypes.OfferChatReceived:
      return {
        ...state,
        chatId: action.payload.chatId,
      };

    case EChatsActionTypes.OnlineStatusReceived:
      return {
        ...state,
        isOnline: action.payload.isOnline,
      };

    case EChatsActionTypes.HintQuestionsReceived:
      return {
        ...state,
        hintQuestions: action.payload.hintQuestions,
      };

    case EChatsActionTypes.OpenChat:
      return {
        ...state,
        isChatOpened: true,
        type: action.payload.type,
        defaultMessage: action.payload.defaultMessage,
        shouldSendDefaultMessage: action.payload.shouldSendDefaultMessage,
      };

    case EChatsActionTypes.CloseChat:
      return {
        ...state,
        isChatOpened: false,
        type: undefined,
        defaultMessage: undefined,
        shouldSendDefaultMessage: undefined,
      };

    default:
      return state;
  }
}
